import makeStyles from '@mui/styles/makeStyles'
import { ClientDisplay } from '../components/ClientList/ClientDisplay'
import { ClientTableTopBar } from '../components/ClientList/ClientTableTopBar'
import { ClientInformationDialog } from '../components/dialogs/ClientInformationDialog'
import { DepositDialog } from '../components/dialogs/DepositDialog'
import { FileImportDialog } from '../components/dialogs/FileImportDialog'
import { MassOrderInputDialog } from '../components/dialogs/MassOrderInputDialog'
import { useTranslation } from 'react-i18next'
import { NewLayout } from '../components/newLayout/NewLayout'
import { useEffect, useState } from 'react'
import { AlertMessageConfirmation } from '../components/dialogs/AlertMessageConfirmation'
import { useClientFilters } from '../hooks/useClientFilters'
import { useClientApi } from '../hooks/useClientApi'
import { newTraderDiary } from '../constants/initialStates'
import { Territory } from '../redux/reducers/territories'
import { useSelector } from '../redux/hooks/useSelector'

const useStyles = makeStyles(theme => ({
  clientDisplayTable: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  clientEssentials: {
    width: '25%',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
  },
  test: {
    background: 'red',
    width: '200px',
    position: 'absolute',
    top: '20px',
    left: '-50px',
    opacity: '0.95',
    textAlign: 'center',
    lineHeight: '25px',
    fontSize: '16px',
    letterSpacing: '1px',
    color: '#f0f0f0',
    transform: 'rotate(-45deg)',
    paddingRight: '18px',
  },
}))

export const ClientList = () => {
  const { t } = useTranslation()
  
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [clientsToExport, setClientsToExport] = useState<number[]>([]);
  const clients = useClientFilters();
  const { exportClients } = useClientApi();
  const [territoryChange, setTerritoryChange] = useState<Territory>();
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [openConfirmationSave, setOpenConfirmationSave] = useState<boolean>(false);
  const clientNameFromEmail = useSelector(state => state.clients.clientName);

  const setShowConfirmationDialog = (open: boolean) => {
    let tmp = [];
    for ( let i=0; i<clients.length; i++) {
      tmp.push(clients[i].clientId);
    }
    setClientsToExport(tmp)
    setShowConfirmation(open);
  }

  const handleConfirmation = () => {
    exportClients(clientsToExport)
    setShowConfirmation(false);
    setClientsToExport([]);
  }

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  }

  const handleConfirmation2 = () => {
    setOpenConfirmation(false)
    setOpenConfirmationSave(true)
  }
  const handleCloseConfirmation2 = () => {
    setOpenConfirmation(false)
  }


  return (
    <NewLayout pageName={t('CLIENT_OVERVIEW')} setTerritoryChange={setTerritoryChange}>
      <ClientTableTopBar 
        setShowConfirmation={setShowConfirmationDialog}
      />
      <ClientDisplay territoryChange={territoryChange}/>
      {/* <ClientInformationDialog 
        setOpenConfirmation={setOpenConfirmation}
        openConfirmationSave={openConfirmationSave}
        setOpenConfirmationSave={setOpenConfirmationSave}
      /> */}
      <FileImportDialog />
      <AlertMessageConfirmation
        alertOpen={showConfirmation}
        onOk={handleConfirmation}
        onCancle={handleCloseConfirmation}
        alertText={t('CLIENT_EXPORT_MESSAGE')}
      />
      {/* <AlertMessageConfirmation
        alertOpen={openConfirmation}
        onOk={handleConfirmation2}
        onCancle={handleCloseConfirmation2}
        alertText={t('DUPLICITY_EMAIL_VALIDATION_TEXT', {name: clientNameFromEmail.name})}
      /> */}
      <DepositDialog />
    </NewLayout>
  )
}
